module.exports = __webpack_public_path__ + "static/media/BusinessCardOrganizer.63e4177a.png";